import React, { memo, useContext, useLayoutEffect, useRef } from 'react';
import { ConfirmationContext } from 'shared/panels/confirmation/state/ConfirmationState';

export const ConfirmationPanel = memo(({ className, title, text, cancelText, confirmText, onClose, onConfirm, onCancel, confirmClassName, customButtons, panel, hideConfirm, hideCancel }) => {
  const { dispatch, visible, data } = useContext(ConfirmationContext);
  const wrapperRef = useRef();

  useLayoutEffect(() => {
    const handleClickOutside = (event) => wrapperRef.current && !wrapperRef.current.contains(event.target) && dispatch({ type: 'CLOSE_POPUP' });
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dispatch]);

  return (
    <>
      {!!visible &&
        <div className={`fixed -top-5 left-0 right-0 overflow-y-auto bg-gray-400 bg-opacity-50 min-h-screen flex flex-col items-center justify-center pb-10 ${visible ? 'block' : 'hidden'}`} style={{ zIndex: 2000 }}>
          <div className={`${className || 'w-96'} flex flex-col rounded-lg shadow-xl mx-3 bg-white`} ref={wrapperRef}>
            <div className="flex  items-center bg-blue-100 rounded-t-lg px-2 py-2" >
              <span className="text-lg">{title}</span>
              <i className="fa fa-times-circle text-red text-4xl mr-auto cursor-pointer" onClick={() => {
                dispatch({ type: 'CLOSE_POPUP' });
                onClose && onClose();
              }} />
            </div>
            {!!panel && <>{panel}</>}
            {!panel && !!text && <div className="flex  items-center bg-white p-4" >{text}</div>}
            <div className={(hideCancel || hideConfirm ? 'justify-center ' : 'justify-between ') + " w-full flex  p-2 bg-blue-100 rounded-b-lg"}>
              {!!customButtons && <>{customButtons}</>}
              {!customButtons &&
                <>
                  {!hideConfirm &&
                    <button className={confirmClassName || "btn-md btn-green w-40 "} onClick={() => onConfirm && onConfirm(data)
                    }>
                      {confirmText ? confirmText : 'تایید'}
                    </button>}
                  {!hideCancel &&
                    <button className="btn-md btn-gray w-40" onClick={() => {
                      dispatch({ type: 'CLOSE_POPUP' });
                      onCancel && onCancel();
                    }}>{cancelText ? cancelText : 'انصراف'}
                    </button>}
                </>}
            </div>
          </div>
        </div>}
    </>
  )
})


export default ConfirmationPanel;
